import { render, staticRenderFns } from "./dataGoods.vue?vue&type=template&id=4763a99c&scoped=true"
import script from "./dataGoods.vue?vue&type=script&lang=js"
export * from "./dataGoods.vue?vue&type=script&lang=js"
import style0 from "./dataGoods.vue?vue&type=style&index=0&id=4763a99c&prod&lang=less&scoped=true"
import style1 from "./dataGoods.vue?vue&type=style&index=1&id=4763a99c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4763a99c",
  null
  
)

export default component.exports